import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { selectFirstSellerInfo } from '../../redux-state/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_FIRST_SELLER_INFO } from '../../redux-state/forms/types';

function FirstSellerInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const firstSellerInfo = useSelector(selectFirstSellerInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_FIRST_SELLER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">First Seller Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Hide Detail' : 'Show Detail'}</div>
          <FormControlLabel
            control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
          />
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Seller First Name"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerFirstName}
              onChange={(e) => handleChange('sellerFirstName', e.target.value)}
            />
            <TextField
              label="Seller Middle Name"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerMiddleName}
              onChange={(e) => handleChange('sellerMiddleName', e.target.value)}
            />
            <TextField
              label="Seller Last Name"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerLastName}
              onChange={(e) => handleChange('sellerLastName', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Seller Company (if applicable)"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerCompany}
              onChange={(e) => handleChange('sellerCompany', e.target.value)}
            />
            <TextField
              label="Seller Address"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerAddress}
              onChange={(e) => handleChange('sellerAddress', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Seller City"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerCity}
              onChange={(e) => handleChange('sellerCity', e.target.value)}
            />
            <TextField
              label="Seller State"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerState}
              onChange={(e) => handleChange('sellerState', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Seller Zip"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerZip}
              onChange={(e) => handleChange('sellerZip', e.target.value)}
            />
            <TextField
              label="Seller Dealer Number (if applicable)"
              variant="outlined"
              fullWidth
              value={firstSellerInfo.sellerDealerNumber}
              onChange={(e) => handleChange('sellerDealerNumber', e.target.value)}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default FirstSellerInformation;
